import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, PayRate, PayRateWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreatePayRate(): UseMutationResult<
  AxiosResponse<PayRate>,
  AxiosError<ErrorMessage>,
  PayRateWrite
> {
  const queryClient = useQueryClient();

  const createPayRate = useCallback((payRate: PayRateWrite): Promise<AxiosResponse<PayRate>> => {
    return client.post('pay-rates/', payRate);
  }, []);
  return useMutation(createPayRate, {
    onSuccess: () => {
      queryClient.invalidateQueries('payRates');
    },
  });
}
